<template>
    <button @click="toggleHighContrast" class="contrast-button">
      <i class="fas fa-adjust"></i> Alto Contraste
    </button>
  </template>
  
  <script>
  export default {
    mounted() {
      if (localStorage.getItem('highContrast') === 'true') {
        document.body.classList.add('high-contrast');
      }
    },
    methods: {
      toggleHighContrast() {
        const isHighContrast = document.body.classList.toggle('high-contrast');
        localStorage.setItem('highContrast', isHighContrast);
      }
    }
  };
  </script>
  
  <style scoped>
  /* Botão de Alto Contraste fixo no canto superior direito */
  .contrast-button {
    position: fixed;
    top: 10px;
    right: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    z-index: 1000;
  }
  
  .contrast-button:hover {
    color: #ffd700;
  }
  
  .contrast-button i {
    font-size: 18px;
  }
  
  /* Estilo de Alto Contraste */
  .high-contrast {
    background-color: #000 !important;
    color: #fff !important;
  }
  
  .high-contrast a {
    color: #00ffff !important;
  }
  </style>